document.addEventListener('DOMContentLoaded', () => {
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const slides = document.querySelectorAll('.dynamic-carousel .swiper-slide');
  const totalSlides = slides.length;

  if (totalSlides > 4 || !isMobile) {
    // Initialize Swiper for slider functionality
    const swiper = new Swiper('.dynamic-carousel-swiper', {
      slidesPerView: isMobile ? 2 : 5.5, // 2 slides per row on mobile
      spaceBetween: 20,
      slidesPerGroup: 1,
      spaceBetween: isMobile ? 15 : 10, // Adjust spacing for mobile
      centeredSlides: false, // Center active slide
      grabCursor: true,
      loop: true, // Infinite scrolling
      navigation: {
        nextEl: '.dynamic-carousel-swiper-next',
        prevEl: '.dynamic-carousel-swiper-prev',
      },
      pagination: {
        el: '.dynamic-carousel-swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 5.5,
          spaceBetween: 20,
          pagination: { clickable: true },
        }
      },
      grid: isMobile
        ? {
            rows: 1,
            fill: 'row',
          }
        :  {},
    });
    
    console.log('Swiper pagination: ', swiper.pagination.el);  
  } else {
    // For fewer slides, display as a grid layout
    const wrapper = document.querySelector('.dynamic-carousel .swiper-wrapper');
    wrapper.style.display = 'grid';
    wrapper.style.gridTemplateColumns = isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)';
    wrapper.style.gap = '20px';

    // Remove Swiper-specific classes to avoid conflicts
    slides.forEach((slide) => {
      slide.classList.remove('swiper-slide');
    });
  }
});